module.exports = flarum.core.compat['helpers/punctuateSeries'];